<template>

    <v-dialog v-model="dialog" width="600px">
      <v-card>
        <p class=".title ma-2">Add host booking to {{heho.huis_code }} </p>
        <v-form ref="addHeho" v-model="addHehoValid">
          
          <v-row v-if="heho.huis_combi > ''" no-gutters>
            <v-col>
              <v-alert border="left" type="warning" class="ma-2">
                Attention: Combi Accommodation <br>
                Units:
                
                <li v-for="(hspl,h) in heho.hspl" :key="h">
                    {{ hspl }}
                </li>
              </v-alert>
            </v-col>
          </v-row>
          <v-row v-if="heho.huis_combi === null && heho.hspl.length > 1" no-gutters>
          <v-col class="ma-2">
            <v-col class="ma-2 px-2">
                <v-select v-model="plan_code" :items="heho.hspl" label="Select allotment planning"
                    :rules="heho_typeRules"></v-select>
            </v-col>
          </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="ma-2 px-2">
                <v-select v-model="heho_type" :items="heho_typeKeuzes" label="Add to planning"
                    :rules="heho_typeRules"></v-select>
            </v-col>
        </v-row>
        <v-row no-gutters> 
            <v-col cols="6" class="pa-2">
                        <date_picker label="Date from"                                 
                                     :date="hehoVanDat"
                                     :startDate="hehoVanDat"
                                     field="hehoVanDat" 
                                     icon="mdi-calendar-month-outline"
                                     @updateData="updateData"/> 
                    </v-col>
                    <v-col cols="6" class="pa-2">
                        <date_picker label="Date until"                                 
                                     :date="hehoTmDat"
                                     :startDate="hehoVanDat"
                                     field="hehoTmDat" 
                                     icon="mdi-calendar-month-outline"
                                     @updateData="updateData"/> 
                    </v-col>

         </v-row>  
         

         <v-row no-gutters>
            <v-col class="ma-2 px-2">
                <guest :isShortVersion="true" :isDense="true" :guest="guest" @updateData="updateData"/>  
            </v-col>                         
        </v-row>

        <v-row no-gutters>                      
            <v-col class="ma-2 px-2">
                <travelparty :isShortVersion="true" :numRowsRemark="2" :travelparty="travelparty" @updateData="updateData"/>
            </v-col>               
        </v-row>

        <v-row v-if="standard_period_check" no-gutters>
            <v-col>
            <v-alert border="left" type="error" class="ma-2">
                This is not a standard bookable period, are you sure you want to add this period?
                <v-checkbox
                v-model="overrule_check"
                label="Yes I understand, please add this period anyway."
            ></v-checkbox>
            </v-alert>
        </v-col>
        </v-row>

        </v-form>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="primary mx-2" small @click="addHeho()" :disabled="!addHehoValid">Save</v-btn>
          <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </template>
    
    <script>
    
    // import {bus} from "../../../main";
    import date_picker from '@/components/ui/date_picker.vue';
    import travelparty from '@/components/plan/hpbz/travelparty.vue'
    import guest from '@/components/plan/hpbz/guest.vue'

    export default {
        components: {
            guest,
            travelparty,
            date_picker
        },data() { 
        return {
          dialog: false,
          addHehoValid: false,
          huis_encrid: null,
          hehoVanDat: null,
          hehoTmDat: null,
          hehoVanDatmenu: false,
          hehoTmDatmenu: false,
          travelparty: {adults: '0', children: '0', babys: '0', pets: '0', remark: ''},
          guest: { name: '', email: '', telephone: '', address: '', city: '' },
          plan_code: '',
          hulpDate: null,
          standard_period_check: false,
          heho_typeKeuzes: ["Host booking","Booking other sales partner"],
          heho_typeRules: [
                v => (v && v.length >= 3) || "A choice is required"
            ],
          overrule_check:false,
          heho_type: 'Host booking',
          heho: {},
        }
      },
      methods: {
        updateData(data){
            this[data.field] = data.value;
        },
        open(huis_encrid) {
          this.$emit("showSnackbar");
          this.dialog = true;
          this.$axios
            .post("ares/json/ares/heho/getHuisToAddHeho.p", {
              header: {
                token: this.$session.get("ARES"),
                clientSessionId: this.$session.id(),
                request: "getHuisToAddHeho"
              },
              getHuisToAddHeho: {
                huis_encrid: huis_encrid
              }
            })
            .then(res => {
              if (res.data.error) {
                console.log(res.data.error);
                 this.loading = false;
              } else {
                this.heho = res.data.getHuisToAddHeho;
                this.loading = false;
              }
            })
            // .finally(() => {
            //   this.loading = false;
            // });
        },
        addHeho() { 
          this.$axios
            .post("ares/json/ares/heho/addHeho.p", {
              header: {
                token: this.$session.get("ARES"),
                clientSessionId: this.$session.id(),
                request: "addHeho"
              },
              addHeho: {
                huis_encrid: this.heho.huis_encrid,
                heho_van_dat: this.$moment(this.hehoVanDat).format('DD-MM-YYYY'),  
                heho_tm_dat: this.$moment(this.hehoTmDat).format('DD-MM-YYYY'), 
                travelparty: this.travelparty,
                overrule_check: this.overrule_check,
                heho_type: this.heho_type,
                plan_code: this.plan_code,
                guest: this.guest
              }
            })
            .then(res => {
              if (res.data.error) {
                console.log(res.data.error);
              }  else { 
                 if (res.data.addHeho.standard_period_check){
                    this.standard_period_check = res.data.addHeho.standard_period_check
                 } else {
                    if(res.data.addHeho.color === 'success'){
                       // this.$router.reload('/huis/onHuis/' + res.data.addHeho.huis_encrid);            
                       // bus.$emit("closeDialog", "reload");
                    }
                    this.$store.dispatch('setSnackbar', {
                      showing: true,
                      text: res.data.addHeho.text,
                      color: res.data.addHeho.color
                    }); 
                    this.$emit('updateData');  
                    this.overrule_check = false;
                    this.standard_period_check = false;
                    this.dialog = false;
                  }
              }
            })
        },
      }
    }
    </script>
    
    